module.exports = __webpack_public_path__ + "img/img9.6ada1bb2.svg";